import axios from 'axios';
import { Image, ImageCollection, ODataResponse, StorageScheme } from 'models';
import { parseException } from './util';

export async function getImages(accessToken: string, folderId: string): Promise<ODataResponse<Image[]>> {
	try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});

		const filter = `$filter=FolderId eq ${folderId}`;

		const response = await instance.get(`/odata/image?${filter}`);
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function getImagesForAncestors(accessToken: string, folderOrImageId: string): Promise<ImageCollection[]> {
	try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});

		const response = await instance.get(`/api/image/ancestors/${folderOrImageId}`);
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function upload(accessToken: string, parentFolderId: string, files: File[], storageScheme: StorageScheme): Promise<ImageCollection[]> {
	try {
		const formData = new FormData();
		let i = 0;
		while (i < files.length) {
			const file = files[i];
			formData.append('images', file);
			i++;
		}

		formData.append('storageScheme', storageScheme);

		const response = await axios({
			headers: {
				Authorization: 'Bearer ' + accessToken,
				'Content-Type': 'multipart/form-data'
			},
			url: `/api/image/${parentFolderId}`,
			data: formData,
			method: 'POST'
		});
		
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function moveImages(accessToken: string, imageIds: string[], newFolderId?: string) {
    try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});
		const response = await instance.post(`/api/image/move?to=${newFolderId ? newFolderId : ''}`, imageIds);
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function deleteImages(accessToken: string, imageIds: string[]) {
    try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});
		const response = await instance.post(`/api/image/delete`, imageIds);
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}